<template>
  <div class="card card-graph flex-fill w-100">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h3 class="card-title mb-0">{{ title }}</h3>
      <router-link
        v-if="historyLink"
        :to="{ name: 'analytics-dashboard-component', params: { deviceId: devId, componentname: 'license' } }"
        class="btn btn-primary btn-sm d-flex align-items-center gap-1"
      >
        <i class="bx bx-history"></i>
        History
      </router-link>
    </div>
    <div class="card-body d-flex">
      <div class="graph flex-grow-1 d-flex flex-col justify-content-center">
        <div class="d-flex flex-column justify-content-center" ref="charRef" style="height: 100%; width: 100%">
          <div class="uptime" :class="{ 'no-data': !hasData }">{{ uptimeStr }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.graph {
  min-height: 160px;
  width: 100%;
  align-items: center;
  font-size: 28px;
}
.graph div div.uptime {
  text-align: center;
  font-weight: bold;
  color: #73bf69;
  padding: 10px;
  word-break: break-word;
}
.graph div div.uptime.no-data {
  color: #8b949e;
  font-size: 14px;
  font-weight: 500;
}
</style>

<script>
import { onMounted, onUnmounted, onBeforeMount, onBeforeUnmount, ref, computed } from 'vue'
import axios from 'axios'
import { useStore } from 'vuex'
import { createQuery } from '@/data/createLicenseQuery'
import { NO_DATA_AVAILABLE } from '@/data/chartEmptyState'

export default {
  name: 'License',
  props: {
    host: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    refresh: {
      type: Number,
      default: 15,
    },
    title: {
      type: String,
      default: 'License',
    },
    devId: {
      type: Number,
      default: 0,
    },
    historyLink: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const timer = ref(null)
    const charRef = ref(null)
    const store = useStore()

    const apiKey = computed(() => store.state.auth.user?.accessToken)
    const apiHost = computed(() => window.apiHost)

    const uptimeStr = ref(NO_DATA_AVAILABLE)
    const hasData = ref(false)

    const resizeObserver = new ResizeObserver(() => {
      // optional resize logic
    })

    async function main() {
      try {
        const query = createQuery(props.host, props.type)
        const response = await axios.post(apiHost.value + '/core/api/v1/analytics/query', query, {
          headers: {
            Authorization: 'Bearer ' + apiKey.value,
            'Content-Type': 'application/vnd.flux',
            Accept: 'application/csv',
          },
        })

        const lines = response.data.split('\n')
        const fields = lines.length > 1 ? lines[1].split(',') : []
        hasData.value = Boolean(fields[6])
        uptimeStr.value = hasData.value ? fields[6] + ' Devices' : NO_DATA_AVAILABLE
      } catch (error) {
        hasData.value = false
        uptimeStr.value = NO_DATA_AVAILABLE
      }
    }

    onMounted(() => {
      main()
      if (props.refresh > 0) {
        timer.value = setInterval(() => {
          main()
        }, props.refresh * 1000)
      }
    })

    onUnmounted(() => {
      if (timer.value) {
        clearInterval(timer.value)
      }
    })

    onBeforeMount(() => {
      window.addEventListener('resize', () => {})
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', () => {})
      resizeObserver.unobserve(charRef.value)
    })

    return {
      charRef,
      uptimeStr,
      hasData,
    }
  },
}
</script>